export default __webpack_public_path__ + "static/warning-f2b48a6d5efa6c6eff6c8feb4704b7a9.png";